module.exports = __webpack_public_path__ + "img/icn_lightMarker.3525fcb0.svg";